"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stockpilePosTypes = void 0;
exports.stockpilePosTypes = {
    SET_ERROR: 'CHOOSE POS STOCKPILE TYPES SET ERROR',
    SET_LOADING: 'CHOOSE POS STOCKPILE TYPES SET LOADING',
    RESET_SELECTED_POS: 'CHOOSE POS STOCKPILE TYPES RESET SELECTED POS',
    GET_LANDING_PAGE_DATA_STOCKPILE: 'CHOOSE POS STOCKPILE TYPES GET LANDING PAGE DATA',
};
